import React from 'react';
import PropTypes from 'prop-types';
// import {
//   DeleteFilled,
//   // MessageOutlined
// } from '@ant-design/icons';
import { Popover, Popconfirm } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

// import { LinkContainer } from 'react-router-bootstrap';
// // Local Deps
// import { editUserRoute } from '../../../../../config/navigation/routes';
// import trashCan from '../../../../../images/trashcan.svg';
// import edit from '../../../../../images/edit.svg';
// import EmailReset from '../EmailReset';

import './Actions.scss';

export default class Actions extends React.PureComponent {
  static propTypes = {
    cellProps: PropTypes.any.isRequired,
    selectedAction: PropTypes.func,
  };

  static defaultProps = {
    selectedAction: (action, id = null, folderName = null) => {
      console.log(action, id, folderName);
    },
  };

  render() {
    const { cellProps, selectedAction } = this.props;
    return (
      <span className="actions-wrapper">
        {/* <button
          onClick={() => {
            selectedAction('reply', cellProps.original);
          }}
        >
          <MessageOutlined />
        </button>
        <Divider type="vertical" /> */}
        {/* 
        <button
          onClick={() => {
            selectedAction('delete', cellProps.original);
          }}
        >
          <DeleteFilled />
        </button> */}
        <Popover content="Archive">
          {/* <button onClick={() => { selectedAction('delete', cellProps.original); }}>
            <i className="fa fa-archive" />
          </button> */}
          <Popconfirm
            title="Are you sure? This action cannot be undone."
            icon={
              <QuestionCircleOutlined
                style={{
                  color: 'red',
                }}
              />
            }
            onConfirm={() => { selectedAction('delete', cellProps.original); }}
          >
            <button>
              <i className="fa fa-archive" />
            </button>
          </Popconfirm>
        </Popover>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/actions/Actions.jsx